import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('adminToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          await axios.get(`${API_URL}/api/admin/verify`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          const username = localStorage.getItem('adminUsername');
          setUser({ username });
        } catch (error) {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminUsername');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, [token]);

  const login = async (username, password) => {
    const response = await axios.post(`${API_URL}/api/admin/login`, {
      username,
      password
    });
    const { token: newToken, username: user } = response.data;
    localStorage.setItem('adminToken', newToken);
    localStorage.setItem('adminUsername', user);
    setToken(newToken);
    setUser({ username: user });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    setToken(null);
    setUser(null);
  };

  const getAuthHeader = () => ({
    headers: { Authorization: `Bearer ${token}` }
  });

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
